import MainTitle from '../../components/MainTitle'
import { NavLink } from 'react-router-dom'
import CardButton from '../../components/CardButton'
import useAuth from '../../hooks/useAuth'
import { useState, useEffect } from 'react'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import ReferralsSlideOut from '../../components/ReferralsSlideOut'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Pagination from '../../components/Pagination'
import {
  faMagnifyingGlass,
  faEye,
  faPlus,
  faSort,
  faSortUp,
  faSortDown,
  faCheckCircle,
  faReply,
  faUser,
} from '@fortawesome/free-solid-svg-icons'
import Modal from '../../components/Modal'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import { data } from 'autoprefixer'

function AdminReferrals() {
  const axios = useAxiosPrivate()
  const navigate = useNavigate()
  const { setShowLoader, showLoader, can, createInfo, auth } = useAuth()

  const [notifications, setNotifications] = useState([])
  const [deleteNotification, setDeleteNotification] = useState({})
  const [showModal, setShowModal] = useState(false)
  const [showReply, setShowReply] = useState(false)
  const [replies, setReplies] = useState([])
  const [reply, setReply] = useState({ reason: '' })
  const [selectedNotification, setSelectedNotification] = useState({})
  const [open, setOpen] = useState(false)

  const [users, setUsers] = useState([])
  const [selectedUser, setSelectedUser] = useState({})

  const [search, setSearch] = useState('')

  const [currentRecords, setCurrentRecords] = useState([])
  const [filteredRecords, setFilteredRecords] = useState([])
  const [nPages, setNumberOfPages] = useState(0)
  const [statusFilter, setStatusFilter] = useState('')
  const [viewNotification, setViewNotification] = useState(false)
  const [notificationData, setNotificationData] = useState({})

  const [currentPage, setCurrentPage] = useState(1)
  
  const [recordsPerPage] = useState(10)

  const [indexOfLastRecord, setIndexOfLastRecord] = useState(10)
  const [indexOfFirstRecord, setIndexOfFirstRecord] = useState(0)
  const [assignUser, setAssignUser] = useState({})

  const [completedRequestsCount, setCompletedRequestsCount] = useState(0) 
  const [totalRefferrals , setTotalRefferals] = useState(0)

  const [modalTitle, setModalTitle] = useState('')



  const [viewType, setViewType] = useState('active');

  const [originalRecords, setOriginalRecords] = useState([])
  const [columnClickCounts, setColumnClickCounts] = useState({})
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'ascending',
  })
  

  const viewClient = (clientId, claimId = null, sessionId = null) => {
    if (sessionId) {
      navigate(`/clients/${clientId}/claims/${claimId}/sessions/${sessionId}`)
    } else {
      navigate(`/clients/${clientId}`)
    }
  }

  const handleClick = (n) => {
    setOpen(true)
    setNotificationData(n)
  }

  const formatDate = (dateString) => {
    return moment(dateString).format('DD/MM/YYYY')
  }

  const sortArray = (array, key, direction) => {
    return [...array].sort((a, b) => {
      const aValue = getNestedValue(a, key)
      const bValue = getNestedValue(b, key)

      if (aValue == null && bValue != null)
        return direction === 'ascending' ? 1 : -1
      if (aValue != null && bValue == null)
        return direction === 'ascending' ? -1 : 1
      if (aValue == null && bValue == null) return 0

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return direction === 'ascending'
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue)
      }

      return direction === 'ascending' ? aValue - bValue : bValue - aValue
    })
  }
  const renderSortArrow = (columnKey) => {
    if (sortConfig.key === columnKey) {
      if (sortConfig.direction === 'ascending') {
        return <FontAwesomeIcon icon={faSortUp} />
      } else {
        return <FontAwesomeIcon icon={faSortDown} />
      }
    }
    return <FontAwesomeIcon icon={faSort} />
  }

  const handleSort = (key) => {
    let newColumnClickCounts = { ...columnClickCounts }
    if (!newColumnClickCounts[key]) {
      newColumnClickCounts[key] = 1
    } else {
      newColumnClickCounts[key]++
    }

    if (newColumnClickCounts[key] === 3) {
      setSortConfig({
        key: null,
        direction: 'descending',
      })
      newColumnClickCounts[key] = 0
      setCurrentRecords(
        originalRecords.slice(indexOfFirstRecord, indexOfLastRecord)
      )
    } else {
      let direction =
        sortConfig.direction === 'ascending' ? 'descending' : 'ascending'
      setSortConfig({ key, direction })

      const sortedRecords = sortArray(originalRecords, key, direction)
      setCurrentRecords(
        sortedRecords.slice(indexOfFirstRecord, indexOfLastRecord)
      )
    }
    setColumnClickCounts(newColumnClickCounts)
  }

  const getUsers = () => {
    axios
      .get('users/all')
      .then((response) => {
        setUsers(response.data.result)
      })
      .catch((error) => {
        console.log('failed to get users')
      })
  }

  const assignUserClicked = (data) => {
    getUsers()
    setAssignUser({})
    setSelectedNotification(data)
    setModalTitle(`Assign User`)
    setShowModal(true)
  }

  const handleViewTypeChange = (type) => {
    setStatusFilter(''); 
    setCurrentPage(1); 
    setViewType(type);
  }


  const getNestedValue = (obj, path) => {
    if (!path || typeof path !== 'string') return undefined
    return path.split('.').reduce((acc, part) => acc?.[part], obj)
  }

  const nextPage = () => {
    if (currentPage < nPages) {
      const newPage = currentPage + 1
      const indexFirst = newPage * recordsPerPage - recordsPerPage
      const indexLast = newPage * recordsPerPage

      setIndexOfFirstRecord(indexFirst)
      setIndexOfLastRecord(indexLast)
      setCurrentPage(newPage)

      const sortedRecords = sortArray(
        filteredRecords,
        sortConfig.key,
        sortConfig.direction
      )
      setCurrentRecords(sortedRecords.slice(indexFirst, indexLast))
    }
  }

  const previousPage = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1
      const indexFirst = (newPage - 1) * recordsPerPage
      const indexLast = newPage * recordsPerPage

      setIndexOfFirstRecord(indexFirst)
      setIndexOfLastRecord(indexLast)
      setCurrentPage(newPage)

      const sortedRecords = sortArray(
        filteredRecords,
        sortConfig.key,
        sortConfig.direction
      )
      setCurrentRecords(sortedRecords.slice(indexFirst, indexLast))
    }
  }

  const handleSearch = (handle) => {
    setIndexOfFirstRecord(0)
    setIndexOfLastRecord(10)
    setCurrentPage(0)
    setCurrentRecords(filteredRecords.slice(0, 10))

    let searchValue = handle.target.value
    setSearch(searchValue)
    let searchString = searchValue.trim().toLowerCase()
    if (searchString.length > 0) {
      let filteredNotifications =
        searchString.length > 0
          ? notifications.filter((e) => {
              return (
                e.title.toLowerCase().match(searchString) ||
                e.body.toLowerCase().match(searchString) ||
                e.type.toLowerCase().match(searchString) ||
                e.created.toLowerCase().match(searchString) ||
                e.meta?.client_reference.toLowerCase().match(searchString) ||
                e.created_at.toLowerCase().match(searchString)
              )
            })
          : notifications
      if (statusFilter) {
        filteredNotifications = filteredNotifications.filter(
          (notification) => notification.title.toLowerCase() === statusFilter
        )
      }
      setFilteredRecords(filteredNotifications)
      setCurrentRecords(
        filteredNotifications.slice(indexOfFirstRecord, indexOfLastRecord)
      )
      setNumberOfPages(
        Math.ceil(filteredNotifications?.length / recordsPerPage)
      )
    } else {
      setFilteredRecords(notifications)
      setCurrentRecords(
        notifications.slice(indexOfFirstRecord, indexOfLastRecord)
      )
      setNumberOfPages(Math.ceil(notifications?.length / recordsPerPage))
    }

    setSortConfig({
      key: null,
      direction: 'descending',
    })
  }

  useEffect(() => {
    if(auth?.token) {
    getNotifications()
    }
  }, [statusFilter, viewType, auth?.token])

  const getNotifications = async () => {
    try {


      const endpoint = viewType === 'completed'
      ? '/notifications/admin/completed'
      : '/notifications/admin'

      setShowLoader(true)
      const response = await axios.get(endpoint)
      const { referrals, replies , count, completed} = response.data.result
      setShowLoader(false)
      
        setCompletedRequestsCount(completed)

      
        setTotalRefferals(count)
      


      let filteredNotifications = referrals

      if (statusFilter) {
        filteredNotifications = filteredNotifications.filter(
          (notification) => notification.title.toLowerCase() === statusFilter
        )
      }

      setNotifications(filteredNotifications)
      setReplies(replies)
      setOriginalRecords(filteredNotifications)
      setFilteredRecords(filteredNotifications)
      setCurrentRecords(
        filteredNotifications.slice(indexOfFirstRecord, indexOfLastRecord)
      )
      setNumberOfPages(
        Math.ceil(filteredNotifications?.length / recordsPerPage)
      )

      

    } catch (error) {
      console.log('Failed to fetch notifications', error)
    }
    setShowLoader(false)
  }


  const deleteNotificationClicked = (notification) => {
    setDeleteNotification(notification)
    setModalTitle(`Mark ${notification.title} as Completed?`)
    setShowModal(true)
  }

  const resetModal = (resetNotifications = true) => {
    setDeleteNotification({})
    setReply({ reason: '' })
    setShowReply(false)
    setNotificationData({})
    setSelectedNotification({})
    setShowModal(false)
    setViewNotification(false)
    if (resetNotifications) {
      setNotifications(notifications)
    }
  }

  const ReplyElement = () => {
    const relatedReplies = replies.filter(
      (r) => r.meta?.original_notification_id === selectedNotification.id
    )

    const replySubmit = async (e) => {
      e.preventDefault()
      setShowLoader(true)
      try {
        const response = await axios.post(`/notifications/create`, {
          body: reply.reason,
          area: 'Admin',
          type: 'System Update',
          meta: {
            ...selectedNotification.meta,
            original_notification_id: selectedNotification.id,
            original_user_id: selectedNotification.created_by,
          },
          user_id: selectedNotification.created_by,
          title: `Response to Admin Request for Client ${selectedNotification.meta.client_reference}`,
        })

        createInfo('success', `Successfully created response`)
        getNotifications()
        resetModal(false)
      } catch (error) {
        console.log(error)
      }

      setShowLoader(false)
    }

    return (
      <form onSubmit={replySubmit}>
        <div className="mb-4">{selectedNotification.body}</div>
        {relatedReplies?.length > 0 && (
          <div className="mb-4 border rounded-md p-2 bg-gray-50">
            <div className="text-sm font-semibold mb-2 text-gray-800">
              Previous Replies:
            </div>
            {relatedReplies.map((reply, index) => (
              <div key={index} className="mb-2 border-b pb-2 last:border-b-0">
                <div className="text-sm text-gray-700 whitespace-pre-line">
                  {reply.body}
                </div>
                <div className="text-xs text-gray-500 mt-1">
                  {new Date(reply.created_at).toLocaleString()}
                </div>
              </div>
            ))}
          </div>
        )}
        <div className="mb-3">
          <div className="text-sm text-gray-700">Reply:</div>
          <textarea
            className="border rounded-md w-full p-2"
            rows="3"
            defaultValue={reply.reason}
            onChange={(e) => (reply.reason = e.target.value)}
          ></textarea>
        </div>

        <div className="flex mt-2 w-full">
          <button
            type="submit"
            className="btn mt-4 mr-4 w-1/2"
            disabled={showLoader}
          >
            {showLoader ? 'Sending...' : 'Send'}
          </button>
          <button
            type="button"
            className="btn red mt-4 w-1/2"
            onClick={resetModal}
          >
            Cancel
          </button>
        </div>
      </form>
    )
  }

  const ModalBody = () => {
    if (deleteNotification.id) {
      return <DeleteNotificationElement />
    }

    if (viewNotification) {
      return <ViewNotificationElement />
    }

    if (showReply) {
      return <ReplyElement />
    }

    if (assignUser) {
      return <AssignUserElement />
    }
  }

  const replyClicked = (data) => {
    setReply({})
    setShowReply(true)
    setSelectedNotification(data)
    setModalTitle(`Reply to this request ${data.title}`)
    setShowModal(true)
  }

  const AssignUserElement = () => {
    const assignUserSubmit = async (e) => {
      e.preventDefault()
      setShowLoader(true)
      try {
        const response = await axios.post(
          `/notifications/assign-user/${selectedNotification.id}`,
          {
            notification_id: selectedNotification.id,
            user_id: JSON.parse(selectedUser).id,
          }
        )
        createInfo('success', `Successfully Assigned User`)
        getNotifications()
        resetModal(false)
      } catch (error) {
        console.log(error)
      }

      setShowLoader(false)
    }

    return (
      <form onSubmit={assignUserSubmit}>
        <div className="mb-3">
          <label
            htmlFor="name"
            className="block font-medium text-gray-600 text-sm"
          >
            Assignee Name
          </label>
          <select
            defaultValue={selectedUser}
            className="px-2 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            required
            onChange={(e) => setSelectedUser(e.target.value)}
          >
            <option disabled value={{}}>
              Select User
            </option>
            {users?.map((user) => {
              return (
                <option key={user.id} value={JSON.stringify(user)}>
                  {user.name}
                </option>
              )
            })}
          </select>
        </div>
        <div className="flex mt-2 w-full">
          <button type="submit" className="btn mt-4 mr-4 w-1/2">
            Assign User
          </button>
          <button
            type="button"
            className="btn red mt-4 w-1/2"
            onClick={resetModal}
          >
            Cancel
          </button>
        </div>
      </form>
    )
  }

  const ViewNotificationElement = () => {
    return (
      <div>
        <div className="mb-3">
          <p className="space-y-1">
            <div>
              {' '}
              <div className="font-medium">Title: </div>
              <span className="text-slate-600">{notificationData.title}</span>
            </div>
            <div className="pb-4">
              <div className="font-medium">Description: </div>
              <span className="text-slate-600">{notificationData.body}</span>
            </div>
            <div className="grid grid-cols-2 space-y-1">
              <div>
                <div className="font-medium">Client Reference: </div>
                <span className="text-slate-600">
                  {notificationData.meta?.client_reference}
                </span>
              </div>
              <div>
                <div className="font-medium">Claim Reference: </div>
                <span className="text-slate-600">
                  {notificationData.meta?.claim_reference}
                </span>
              </div>
              <div>
                <div className="font-medium">Request Date: </div>
                <span className="text-slate-600">
                  {formatDate(notificationData.meta?.requested_at)}
                </span>
              </div>
              <div>
                <div className="font-medium">Requested By: </div>
                <span className="text-slate-600">
                  {notificationData.created}
                </span>
              </div>
              {notificationData.meta?.session_id && (
                <div className="flex items-center justify-between col-span-2">
                  <div>
                    <div className="font-medium">Session ID: </div>
                    <span className="text-slate-600">
                      {notificationData.meta?.session_id}
                    </span>
                  </div>
                  <div className="w-1/2">
                    <div className="font-medium">Session Date Created: </div>
                    <span className="text-slate-600">
                      {formatDate(notificationData.meta?.session_date)}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </p>
          <div className="flex mt-2 w-full">
            {notificationData.meta?.session_id ? (
              <button
                onClick={() =>
                  viewClient(
                    notificationData.meta?.client_id,
                    notificationData.meta?.claim_id,
                    notificationData.meta?.session_id
                  )
                }
                className="btn mt-4 mr-4 w-1/2"
              >
                <span>View Session</span>
              </button>
            ) : (
              <button
                onClick={() => viewClient(notificationData.meta?.client_id)}
                className="btn mt-4 mr-4 w-1/2"
              >
                <span>View Client</span>
              </button>
            )}

            <button
              type="button"
              className="btn red mt-4 w-1/2"
              onClick={resetModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    )
  }

  const DeleteNotificationElement = () => {
    const deleteNotificationFn = async (e) => {
      e.preventDefault()
      setShowLoader(true)
      resetModal(false)
      try {
        await axios.get('/notifications/delete/' + deleteNotification.id)
        createInfo(
          'success',
          `Completed Notification: ${deleteNotification.title}`
        )

        setCurrentRecords(
          currentRecords.filter((notification) => {
            return notification.id !== deleteNotification.id
          })
        )
        setNotifications(
          notifications.filter((notification) => {
            return notification.id !== deleteNotification.id
          })
        )

        setShowLoader(false)
      } catch (error) {
        setShowLoader(false)
      }
    }

    return (
      <form onSubmit={deleteNotificationFn}>
        <div className="mb-3">
          <p className="text-lg font-bold my-8 text-center">
            Are you sure you want to mark this notification as completed?
          </p>
          <div className="flex mt-2 w-full">
            <button className="btn green mt-4 mr-4 w-1/2">Complete</button>

            <button
              type="button"
              className="btn red mt-4 w-1/2"
              onClick={resetModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    )
  }

  return (
    <section>
      {showModal && (
        <Modal title={modalTitle} body={<ModalBody />} show={resetModal} />
      )}
      <MainTitle title="Admin Requests" />

      <section>
        {showModal && (
          <Modal title={modalTitle} body={<ModalBody />} show={resetModal} />
        )}
        <ul className="flex just-between flex-wrap">
          {can('create notifications') && (
            <li className="w-1/4 mb-6 mr-3">
              <NavLink to="new">
                <CardButton icon={faPlus} title="Create New Notification" />
              </NavLink>
            </li>
          )}
          <buttton onClick={() => setViewType('active')} className="rounded-md bg-white shadow h-20 w-1/4 px-4 mb-6 flex flex-col justify-center cursor-pointer mr-3">
    <h2 class="font-bold">Total Requests</h2>
    <p class="text-3xl font-black">{totalRefferrals}</p>
    
</buttton>
<button
    className="rounded-md bg-red-100 shadow h-20 w-1/4 px-4 mb-6 flex flex-col justify-center items-start mr-3" 
    onClick={() => setViewType('completed')}
>
    <h2 className="font-bold">Completed Requests</h2> 
    <p className="text-3xl font-black">{completedRequestsCount}</p> 
</button>
        </ul>
      </section>
      <div className="flex justify-between ">
        <div className="py-4">
          <div className="relative mt-1">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                onClick={handleSearch}
              />
            </div>
            <input
              type="text"
              id="table-search"
              onChange={handleSearch}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-80 pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Search Referrals"
            />
          </div>
        </div>
      </div>
      <table className="table-main">
        <thead>
          <tr>
            <th
              className="cursor-pointer"
              scope="col"
              onClick={() => handleSort('meta.client_reference')}
            >
              Client Reference {renderSortArrow('meta.client_reference')}
            </th>
            <th
              className="cursor-pointer"
              scope="col"
              onClick={() => handleSort('title')}
            >
              Title {renderSortArrow('title')}
            </th>
            <th
              className="cursor-pointer"
              scope="col"
              onClick={() => handleSort('body')}
            >
              Body {renderSortArrow('body')}
            </th>
            <th
              className="cursor-pointer"
              scope="col"
              onClick={() => handleSort('created')}
            >
              Created By {renderSortArrow('created')}
            </th>
            <th
              className="cursor-pointer"
              scope="col"
              onClick={() => handleSort('assigned')}
            >
              Assigned {renderSortArrow('assigned')}
            </th>
            <th
              className="cursor-pointer"
              scope="col"
              onClick={() => handleSort('created_at')}
            >
              Created At {renderSortArrow('created_at')}
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody className="table-main">
          {currentRecords.length > 0 ? (
            currentRecords.map((notification) => {
              return (
                <tr key={notification.id}>
                  <td>{notification.meta.client_reference}</td>
                  <td>{notification.title}</td>
                  <td>{notification.body}</td>
                  <td>{notification.created}</td>
                  <td>
                    {notification.assigned == null
                      ? 'Unassigned'
                      : notification.assigned.name}
                  </td>
                  <td>
                    {moment(notification.created_at).format('DD/MM/YYYY')}
                  </td>
                  <td>
                    <div className="flex justify-center space-x-2">
                      <span
                        title="View"
                        onClick={() => handleClick(notification)}
                        className="flex justify-center items-center bg-blue-400 rounded-md text-blue-800 h-9 w-12 hover:bg-blue-500 cursor-pointer"
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </span>
                      <span
                        title="Assign User"
                        onClick={() => assignUserClicked(notification)}
                        className="flex justify-center items-center bg-orange-400 rounded-md text-orange-800 h-9 w-12  hover:bg-orange-500 cursor-pointer"
                      >
                        <FontAwesomeIcon icon={faUser} />
                      </span>
                      <span
                        title="Reply"
                        onClick={() => replyClicked(notification)}
                        className="flex justify-center items-center bg-pink-400 rounded-md text-pink-800 h-9 w-12  hover:bg-pink-500 cursor-pointer"
                      >
                        <FontAwesomeIcon icon={faReply} />
                      </span>
                      {viewType !== 'completed' && (<span
                        title="Complete"
                        onClick={() => deleteNotificationClicked(notification)}
                        className="flex justify-center items-center bg-green-400 rounded-md text-green-800 h-9 w-12 hover:bg-green-500 cursor-pointer"
                      >
                        <FontAwesomeIcon icon={faCheckCircle} />
                      </span>)}
                    </div>
                  </td>
                </tr>
              )
            })
          ) : (
            <tr>
              <td colSpan={7}>
                <p className="no-records">No notifications found</p>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <Pagination
        next={nextPage}
        prev={previousPage}
        first={indexOfFirstRecord}
        last={indexOfLastRecord}
        total={filteredRecords?.length}
      />

      <ReferralsSlideOut
        open={open}
        setOpen={setOpen}
        notificationData={notificationData}
        viewClient={viewClient}
        replies={replies}
      />
    </section>
  )
}

export default AdminReferrals
